module.exports = __webpack_public_path__ + "img/qrcode_bgv2.2b2b97df.jpg";